// extracted by mini-css-extract-plugin
export default {"editorWrap":"Editor_editorWrap__UX3j4","editorInput":"Editor_editorInput__eCEV4","placeholder":"Editor_placeholder__b2jPI","toolbar":"Editor_toolbar__X+7+N"};